module.exports = __webpack_public_path__ + "8707e07146d37f0b81829bb387e4f773.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-BoldItalic.svg
// module id = 414
// module chunks = 0